import { createStyles, makeStyles, Theme, focusStyle, space } from 'ui-components';

const getBaseFlexContainerStyle = {
  maxWidth: space.dataWizardContentMaxWidth,
  margin: '0 auto' as const,
  display: 'flex' as const,
  flexWrap: 'nowrap' as const,
  gap: 24,
};

const getBaseFlexContainerMobileStyle = {
  flexDirection: 'column' as const,
  alignItems: 'center' as const,
};

const getHalfWidthWrapperStyle = {
  flexGrow: 0,
  maxWidth: '50%',
  flexBasis: '50%',
};

const getHalfWidthWrapperMobileStyle = {
  width: '100%',
  maxWidth: '100%',
  flexBasis: '100%',
};

export default makeStyles((theme: Theme) => createStyles({
  container: {
    ...getBaseFlexContainerStyle,
    marginTop: 32,
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      ...getBaseFlexContainerMobileStyle,
      margin: '24px auto',
      gap: 16,
    },
  },
  boxWithIconWrapper: {
    ...getHalfWidthWrapperStyle,
    '&:focus-visible': {
      ...focusStyle(theme),
    },
    [theme.breakpoints.down('sm')]: {
      ...getHalfWidthWrapperMobileStyle,
    },
  },
  noteContainer: {
    ...getBaseFlexContainerStyle,
    [theme.breakpoints.down('sm')]: {
      ...getBaseFlexContainerMobileStyle,
      marginBottom: 64,
      gap: 0,
    },
  },
  noteWrapper: {
    ...getHalfWidthWrapperStyle,
    [theme.breakpoints.down('sm')]: {
      ...getHalfWidthWrapperMobileStyle,
      '&:last-of-type': {
        marginTop: 16,
      },
    },
  },
}), { name: 'ChoiceSteps' });
